import { Space } from "antd"
import { notifications } from "../../../notifications"
import { CopyOutlined } from "@ant-design/icons"
import { OneLineTags } from "../../accounts/components/one-line-tags"

export const GameCategoryOrderColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (id: string) => {
      return (
        <div
          onClick={() => {
            navigator.clipboard.writeText(id)
            notifications.success("Copied id:" + id)
          }}
          style={{
            background: "#A3A3A3",
            width: 24,
            height: 24,
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          <CopyOutlined
            style={{ color: "white", display: "flex", transform: "translate(5px, 2px)" }}
          />
        </div>
      )
    },
  },
  {
    title: "Order Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Category & Games",
    dataIndex: "categories",
    key: "categories",
    render: (categories: { name: string; platformIds: string[] }[]) => {
      if (!categories.length) {
        return <div>Empty</div>
      }

      return (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {categories.map((item, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #f0f0f0",
                borderRadius: 4,
                padding: 8,
                background: "#fafafa",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <div>{item.name}:</div>
              <div
                style={{
                  display: "flex",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  flex: 1,
                  gap: 4,
                }}
              >
                <Space size={[4, 4]} wrap>
                  <OneLineTags tags={item.platformIds} />
                </Space>
              </div>
            </div>
          ))}
        </div>
      )
    },
  },
]

